import React, { useContext } from 'react'
import { AppContext } from '../../../App'
import ResinousApplication from './ResinousApplication'

export default function ResinousApplicationList() {
    const { resinousApplicationsData } = useContext(AppContext)
   return (
      <div className="panel panel-primary">
         <div className="panel-heading">
            <h4 className="panel-title">Select Resinous Application</h4>
         </div>
         <div className="panel-body">
               {
            resinousApplicationsData.map(r => {
               return r.text==="Floor" && <ResinousApplication key={r.text} {...r} />
            })
         }
         {
            resinousApplicationsData.map(r => {
               return r.text==="Wall" &&  <ResinousApplication key={r.text} {...r} />
            })
         }
         {
            resinousApplicationsData.map(r => {
               return r.text==="Cove" &&  <ResinousApplication key={r.text} {...r} />
            })
         }
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousApplicationList.js